module.exports = __webpack_public_path__ + "img/graph-messages.9f0e184b.svg";